import PlusIcon from "@mui/icons-material/Add";
import {
  Avatar,
  Box,
  Button,
  Stack,
  SvgIcon,
  Typography,
  useTheme,
  alpha
} from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../core/hooks/useStore";
import { RootState } from "../../core/store/store";
import { CreateProjectDialog } from "./create-project-dialog";
import projectsSlice from "./projects.slice";

const ProjectsHeader = (props: any) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const { apiUrl } = useSelector((state: RootState) => state.home);
  const projectsState = useSelector((state: RootState) => state.projects);

  const handleOpen = () => {
    dispatch(projectsSlice.actions.setCreateDialogOpened(true));
  };

  const handleClose = () => {
    dispatch(projectsSlice.actions.setCreateDialogOpened(false));
  };

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 0 }}>
            Projects
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Manage your content projects and articles
          </Typography>
        </Box>
        <Button
          onClick={handleOpen}
          size="large"
          startIcon={<PlusIcon />}
          variant="contained"
          sx={{ 
            px: 3,
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            '&:hover': {
              background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
            }
          }}
        >
          Create Project
        </Button>
        <CreateProjectDialog
          onClose={handleClose}
          open={projectsState.createDialogOpened}
        />
      </Stack>
    </>
  );
};

export default ProjectsHeader;